import { NookKind } from "@nook/schema";
export const localDay = (date) => date.toLocaleDateString("en-CA");
export const dayStart = (day) => new Date(`${day}T00:00`);
export const DATE_PRESETS = [
    ["today", "Today"],
    ["7d", "Last 7 days"],
    ["30d", "Last 30 days"],
    ["year", "This year"],
];
/** Whole local days ending today. */
export function presetRange(preset, now = new Date()) {
    const back = { today: 0, "7d": 6, "30d": 29 };
    const from = preset === "year"
        ? new Date(now.getFullYear(), 0, 1)
        : new Date(now.getFullYear(), now.getMonth(), now.getDate() - back[preset]);
    return { from: localDay(from), to: localDay(now) };
}
export function matchPreset(from, to, now = new Date()) {
    if (!from)
        return null;
    return DATE_PRESETS.map(([preset]) => preset).find((preset) => {
        const range = presetRange(preset, now);
        return range.from === from && range.to === to;
    }) ?? null;
}
/** `note` is the Notes tab: nooks with no URL or image. Without it, the Library: every other nook. */
export function browseFilters({ site, from, to }, kind = NookKind.Capture) {
    return {
        site,
        kind,
        from: from ? dayStart(from).toISOString() : undefined,
        to: to ? new Date(`${to}T23:59:59.999`).toISOString() : undefined,
    };
}
//# sourceMappingURL=browse.js.map